import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { formatRotationDegreesLabel } from "./layerRotation";

const CURSOR_OFFSET_X = 16;
const CURSOR_OFFSET_Y = 16;

const guideEqual = (left, right) =>
  left?.label === right?.label && left?.x === right?.x && left?.y === right?.y;

// eslint-disable-next-line
export const syncRotationAngleGuide = (ref, { degrees, event } = {}) => {
  if (!event || typeof event.clientX !== "number") return;
  ref?.current?.setGuide({
    degrees,
    clientX: event.clientX,
    clientY: event.clientY,
  });
};

const RotationAngleOverlay = forwardRef((_, ref) => {
  const overlayRef = useRef(null);
  const [guide, setGuide] = useState(null);

  useImperativeHandle(
    ref,
    () => ({
      setGuide: ({ degrees, clientX, clientY }) => {
        const overlay = overlayRef.current;
        if (!overlay) return;
        const rect = overlay.getBoundingClientRect();
        const next = {
          label: formatRotationDegreesLabel(degrees),
          x: clientX - rect.left + CURSOR_OFFSET_X,
          y: clientY - rect.top + CURSOR_OFFSET_Y,
        };
        setGuide((current) => (guideEqual(current, next) ? current : next));
      },
      clear: () => {
        setGuide((current) => (current ? null : current));
      },
    }),
    []
  );

  return (
    <Box
      ref={overlayRef}
      data-rotation-angle-root=""
      sx={{
        position: "absolute",
        inset: 0,
        overflow: "visible",
        pointerEvents: "none",
        zIndex: 6,
      }}
    >
      {guide ? (
        <Typography
          component="span"
          sx={{
            position: "absolute",
            left: guide.x,
            top: guide.y,
            px: 0.9,
            py: 0.25,
            borderRadius: "999px",
            bgcolor: "#18181B",
            color: "#fff",
            fontSize: "11px",
            fontWeight: 600,
            lineHeight: "16px",
            letterSpacing: "0.01em",
            whiteSpace: "nowrap",
            boxShadow: "0 4px 12px rgba(0,0,0,.28)",
            pointerEvents: "none",
            userSelect: "none",
          }}
        >
          {guide.label}
        </Typography>
      ) : null}
    </Box>
  );
});

RotationAngleOverlay.displayName = "RotationAngleOverlay";

export default RotationAngleOverlay;
